export default __webpack_public_path__ + "static/media/bu-logo-horizontal.6e51a709.png";